import { render, staticRenderFns } from "./DimensionBulkButton.vue?vue&type=template&id=c7207a18&scoped=true&"
import script from "./DimensionBulkButton.vue?vue&type=script&lang=js&"
export * from "./DimensionBulkButton.vue?vue&type=script&lang=js&"
import style0 from "./DimensionBulkButton.vue?vue&type=style&index=0&id=c7207a18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7207a18",
  null
  
)

export default component.exports